<div class="my-2">
    <ngx-charts-bar-vertical [scheme]="config.colorScheme" [results]="data" [gradient]="config.gradient"
        [xAxis]="config.showXAxis" [yAxis]="config.showYAxis" [legend]="config.showLegend"
        [showXAxisLabel]="config.showXAxisLabel" [showYAxisLabel]="config.showYAxisLabel"
        [xAxisLabel]="config.xAxisLabel" [yAxisLabel]="config.yAxisLabel" (select)="onSelect($event)">
    </ngx-charts-bar-vertical>
</div>